import { createApi } from '@reduxjs/toolkit/query/react';

import { customBaseQueryWithReauth } from '../refresh/customBaseQuery';

export const USER_PATH = 'otp';

export const otpApi = createApi({
    reducerPath: USER_PATH,
    refetchOnMountOrArgChange: true,
    refetchOnReconnect: true,
    refetchOnFocus: true,
    keepUnusedDataFor: 0,
    baseQuery: customBaseQueryWithReauth,
    endpoints: (builder) => ({
        sendOtp: builder.mutation<any, { email: string }>({
            query: (requestBody) => ({
                url: '/send',
                method: 'POST',
                body: JSON.stringify(requestBody)
            })
        }),
        postVerifyOtp: builder.mutation<any, { email: string; otpcode: number }>({
            query: (requestBody) => ({
                url: '/verify',
                method: 'POST',
                body: JSON.stringify(requestBody)
            })
        })
    })
});

export const { usePostVerifyOtpMutation, useSendOtpMutation } = otpApi;
